<template>
  <v-app>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'App',
  components: {},
  data: () => ({
    //
  }),
  created() {
    this.fetchComposite();
  },
  methods: {
    ...mapActions(['fetchComposite']),
  },
};
</script>
<style lang="scss">
html body {
  font-size: 16px;
  height: 100%;
  overflow: hidden;
  padding: 0;
  margin: 0;
}
.v-overlay__content {
  height: 100%;
  width:100%;
}
p {
  font-size: 1rem;
}

.btnCont {
  display: flex;
  margin-top: 20px;
  width: 100%;
  justify-content: space-between;
}
.spacing {
  margin: 0 10px;
}
.card-style-title {
  font-size: 1.5em;
  padding: 1em 0;
  justify-content: center;
  text-align: center;
  margin: 10px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  font-weight: 400;
  letter-spacing: normal;
  line-height: 2rem;
  padding: 16px 16px 8px;
  word-break: break-all;
  color: #00486b;
  border-top: solid 5px #e04074;
}

.v-menu__content {
    z-index: 10000 !important;
  }

.sub-text {
  color: #5a5959;
  padding: 0 16px 16px 16px;
}

@media (min-width: 360px) {
  .card-style-title {
    font-size: 2em;
    word-break: normal !important;
    padding: 15px 0;
  }
  .btnCont {
    width: 100%;
    justify-content: space-between;
  }
}
@media (min-width: 650px) {
  .card-style-title {
    font-size: 2em;
    margin: 10px;
  }
  .btnCont {
    justify-content: space-between;
    margin-top: 15px;
  }
}
// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {  }

// Large devices (desktops, 992px and up)
@media (min-width: 992px) {  }

// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1680px) {
  .card-style-title {
    text-align: left;
    font-size: 2em;
    margin: 10px;
    justify-content: space-between;
  }
  .btnCont {
    margin-top: 0;
    width: 14rem;
  }
 }
</style>
